export const TITLE_MAX_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH = 200;

export const normalizeIssueDefinition = ({ title, description, noPriority }) => ({
   title: String(title || '').trim(),
   description: String(description || '').trim() || null,
   noPriority: noPriority === '' || noPriority == null ? null : Number(noPriority)
});

export const getIssueDefinitionForm = (issue = {}) => ({
   title: issue.title || '',
   description: issue.description || '',
   noPriority: issue.noPriority == null ? '' : String(issue.noPriority)
});

export const validateIssueDefinition = ({ title, description }) => ({
   titleRequired: !String(title || '').trim(),
   titleTooLong: String(title || '').length > TITLE_MAX_LENGTH,
   descriptionTooLong: String(description || '').length > DESCRIPTION_MAX_LENGTH
});

export const sameIssueDefinition = (left, right) => {
   const a = normalizeIssueDefinition(left || {});
   const b = normalizeIssueDefinition(right || {});
   return a.title === b.title && a.description === b.description && a.noPriority === b.noPriority;
};
